<template>
	<div class="stepper">
		<v-layout wrap align-center class="pos-relative">
			<v-btn
				fab
				dark
				depressed
				small
				color="info" class="arrow-container left"
				:style="`background-color:${$appColors.info} !important`"
				@click="scrollLeft">
				<v-icon dark size="40">keyboard_arrow_left</v-icon>
			</v-btn>
				<v-layout row
					class="overflow-container"
					ref="scrollContainer">
					<div
						v-for="(step, index) in steps"
						:key="index"
						class="step"
						ref="stepElement">
						<div class="step-index" :class="{'completed': index + 1 <= currentStep}">
							{{ index + 1 }}
						</div>
						<div class="step-label" :class="{'completed': index + 1 <= currentStep}">
							{{ step.label }}
						</div>
					</div>
				</v-layout>
			<v-btn
				fab
				dark
				depressed
				small
				color="info" class="arrow-container right"
				:style="`background-color:${$appColors.info} !important`"
				@click="scrollRight">
				<v-icon dark size="40">keyboard_arrow_right</v-icon>
			</v-btn>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'Stepper',
	mounted() {
		this.scrollToCurrentStep();
	},
	props: ['steps', 'currentStep'],
	methods: {
		scrollToCurrentStep() {
			const stepElements = this.$refs.stepElement;
			const currentStepElement = stepElements[this.currentStep - 1];
			if (currentStepElement) {
				currentStepElement.scrollIntoView({
					behaivor: 'smooth',
					block: 'center',
				});
			}
		},
		scrollLeft() {
			const container = this.$refs.scrollContainer;
			container.scrollLeft -= 100;
		},
		scrollRight() {
			const container = this.$refs.scrollContainer;
			container.scrollLeft += 100;
		},
	},
	watch: {
		currentStep() {
			this.scrollToCurrentStep();
		},
	},
};
</script>

<style lang="scss" scoped>
.stepper {
	// display: inline-block;
	display: flex;
	position: relative;
	user-select: none;
	&:after {
		content: '';
		border-top: 1px solid var(--app-color-primary);
		position: absolute;
		width: 90%;
		top: 20px;
		left: 20px;
	}
	.step:last-child {
		margin-right: 0px;
	}
	.step {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		margin-right: 80px;
		position: relative;
		z-index: 1;
		.step-index {
			display: inline-flex;
			width: 40px;
			height: 40px;
			border: 1px solid var(--app-color-primary);
			border-radius: 50%;
			justify-content: center;
			align-items: center;
			font-size: 20px;
			color: var(--app-color-primary);
			background-color: white;
			margin-bottom: 10px;
			&.completed {
				background-color: var(--app-color-primary);
				color: white;
			}
		}
		.step-label {
			width: 60px;
			text-align: center;
			color: var(--app-color-primary);
			font-size: 12px;
			line-height: 14px;
			&.completed {
				font-weight: bold;
			}
		}
	}
	.pos-relative {
		position: relative;
	}
	.arrow-container {
		bottom: 0px;
		margin: auto;
		position: absolute;
		top: 0px;
		&.left {
			left: -41px;
		}
		&.right {
			right: -41px;
		}
	}
	.overflow-container {
		overflow-x: auto;
		background-color: map-get($colors, white);
		max-width: 100%;
		padding: 0 30px;
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}
	.overflow-container::-webkit-scrollbar {
		width: 100%;
	}

	// .overflow-container::-webkit-scrollbar-thumb {
	// background-color: transparent;
	// }
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/stepper/stepper-carrusel.vue